// Components==============
import { useEffect, useState } from 'react';
import shuffleArray from './shuffleArray';
// =========================

export function useCombineAndShuffleArrays(categories: any[]) {
    const [words, setWords] = useState<any[]>([]);

    useEffect(() => {
        if (words.length < 1) {
            const arraysCombined = [].concat(
                ...categories.map((cat: any) => cat.words)
            );
            const tempWords: string[] = [];
            const uniqueArray = arraysCombined
                .map((word: any) => {
                    if (tempWords.includes(word.name) === true) return null;
                    tempWords.push(word.name);
                    return word;
                })
                .filter((exists) => exists);

            shuffleArray(uniqueArray);
            setWords(uniqueArray);
        }
    }, [categories]);

    return words;
}
